export const jitterEdges = [
  {
    id: "147.32.3.202-2620:0:862:ed1a::1",
    source: "2620:0:862:ed1a::1",
    target: "147.32.3.202",
    type: "straight",
  },
  {
    id: "126.134.35.41-147.32.3.202",
    source: "126.134.35.41",
    target: "147.32.3.202",
    type: "straight",
  },
  {
    id: "126.134.35.41-71dd::ad48:7474:3412",
    source: "126.134.35.41",
    target: "71dd::ad48:7474:3412",
    type: "straight",
  },
  {
    id: "224.109.172.5-71dd::ad48:7474:3412",
    source: "224.109.172.5",
    target: "71dd::ad48:7474:3412",
    type: "straight",
  },
  {
    id: "81.119.95.47-224.109.172.5",
    source: "81.119.95.47",
    target: "224.109.172.5",
    type: "straight",
  },
  {
    id: "81.119.95.47-2bb6::ae76:435a::1246",
    source: "81.119.95.47",
    target: "2bb6::ae76:435a::1246",
    type: "straight",
  },
  {
    id: "195.113.89.35-2bb6::ae76:435a::1246",
    source: "195.113.89.35",
    target: "2bb6::ae76:435a::1246",
    type: "straight",
  },
];
